import { axios } from '@/utils/request'

/**
 * 查询处方审核
 *
 * @author 张禹尧
 * @date 2022-04-15 09:33:15
 */
export function baUserPointsRewardPage (parameter) {
  return axios({
    url: '/baUserPointsReward/page',
    method: 'get',
    params: parameter
  })
}
/**
 * 处方审核列表
 *
 * @author 张禹尧
 * @date 2022-04-15 09:33:15
 */
export function recipeList (parameter) {
  return axios({
    url: '/checkrecipe/list',
    method: 'get',
    params: parameter
  })
}

/**
 * 添加处方审核
 *
 * @author 张禹尧
 * @date 2022-04-15 09:33:15
 */
export function recipeAdd (parameter) {
  return axios({
    url: '/checkrecipe/add',
    method: 'post',
    data: parameter
  })
}

/**
 * 编辑处方审核
 *
 * @author 张禹尧
 * @date 2022-04-15 09:33:15
 */
export function recipeEdit (parameter) {
  return axios({
    url: '/checkrecipe/edit',
    method: 'post',
    data: parameter
  })
}

/**
 * 删除处方审核
 *
 * @author 张禹尧
 * @date 2022-04-15 09:33:15
 */
export function recipeDelete (parameter) {
  return axios({
    url: '/checkrecipe/delete',
    method: 'post',
    data: parameter
  })
}

/**
 * 导出处方审核
 *
 * @author 张禹尧
 * @date 2022-04-15 09:33:15
 */
export function recipeExport (parameter) {
  return axios({
    url: '/checkrecipe/export',
    method: 'get',
    params: parameter,
    responseType: 'blob'
  })
}


/**
 * 查询处方审核详情
 *
 * @author LIWEI
 * @date 2022-04-07 14:16:06
 */
export function recipeDetial (parameter) {
  return axios({
    url: '/checkrecipe/detail',
    method: 'get',
    params: parameter
  })
}


/**
 * 调用审核通过按钮
 *
 * @author LIWEI
 * @date 2022-04-07 14:16:06
 */
export function recipeAdopt (parameter) {
  return axios({
    url: '/checkrecipe/sign',
    method: 'get',
    params: parameter
  })
}



/**
 * 调用审核驳回按钮
 *
 * @author LIWEI
 * @date 2022-04-07 14:16:06
 */
export function recipeCancel (parameter) {
  return axios({
    url: '/checkrecipe/noSign',
    method: 'get',
    params: parameter
  })
}



/**
 * 外配处方 需要调用处方核验
 * 
 */
export function recipePreVer(parameter) {
   return axios({
    url: '/checkrecipe/uploadPreVerification',
    method: 'get',
    params: parameter
  })
}



/**
 * 外配处方 还需调用处方上传
 */
export function recipeUpload(parameter) {
   return axios({
    url: '/checkrecipe/recipeUpload',
    method: 'get',
    params: parameter
  })
}